import Result1 from '../assets/images/용감한탐험가.png';
import Result2 from '../assets/images/신중한관찰자.png';
import Result3 from '../assets/images/조심스러운회피자.png';
import Result4 from '../assets/images/독립적인해결사.png';

export const RESULT_IMAGES = [Result1, Result2, Result3, Result4];
